import { useParams } from 'react-router-dom';
import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { MultipleSelect, SelectOption } from '~/components';

const AnatomyField = () => {
  const datasetId = +useParams().id!;
  const { data: anatomyOptions, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.ANATOMY });

  const selectOptions: SelectOption[] =
    anatomyOptions?.map(({ value }) => ({
      value,
      label: value.replace(/_/g, ' '),
    })) || [];

  return (
    <MultipleSelect
      name="anatomy"
      label="ANATOMY"
      options={selectOptions}
      placeholder="Select the anatomy"
      disabled={isFetching || !!datasetId}
    />
  );
};

export default AnatomyField;
